export default {
  currentVersion: 'versión actual',
  selectVersion: 'Seleccionar versión',
  goToCurrentVersion: 'Ir a la versión actual (v{version})',
  versionDeployed: 'Desplegada el {date}'
}
